/* eslint-disable no-prototype-builtins */
/* eslint-disable eqeqeq */
import { isDate, isEmpty, isObject, properObject } from "@/utils/utils";

export const updatedDiff = <T>(
  lhs: T,
  rhs: Record<string, unknown> | T,
  omitRules: Array<string | ((key: string) => boolean)> = []
): Partial<NonNullable<T>> => {
  if (lhs === rhs) return {};

  if (!isObject(lhs) || !isObject(rhs)) return rhs as Partial<NonNullable<T>>;

  const l = properObject(lhs as Record<string, unknown>);
  const r = properObject(rhs as Record<string, unknown>);

  if (isDate(l) || isDate(r)) {
    if (l.valueOf() == r.valueOf()) return {};
    return r as Partial<NonNullable<T>>;
  }

  return Object.keys(r).reduce((acc, key) => {
    for (const rule of omitRules) {
      if (typeof rule === "string") {
        if (key === rule) return acc;
      } else if (typeof rule === "function") {
        if (rule(key)) return acc;
      }
    }

    if (l.hasOwnProperty(key)) {
      const difference = updatedDiff(
        l[key as string] as Record<string, unknown>,
        r[key as string] as Record<string, unknown>,
        omitRules
      );

      if (isObject(difference) && isEmpty(difference) && !isDate(difference))
        return acc;

      return { ...acc, [key]: difference };
    }

    return acc;
  }, {});
};
